import { gql } from '@apollo/client';

export const GET_ALL_DOME_DOCUMENTS_QUERY = gql`
  query GetAllDomeDocuments($assetId: Int!, $folderPrefix: String) {
    getAllDomeDocuments(
      input: { assetId: $assetId, folderPrefix: $folderPrefix }
    ) {
      statusCode
      message
      documents {
        id
        assetId
        documentName
        documentType
        documentUrl
        description
        createdAt
      }
    }
  }
`;
